import { SHADOW_SIZE } from './inject';
const DEFAULT_POSITION_MARGIN = 24;
export const positions = {
    default: () => ({
        bottom: `${DEFAULT_POSITION_MARGIN - SHADOW_SIZE}px`,
        right: `${DEFAULT_POSITION_MARGIN - SHADOW_SIZE}px`,
    }),
    bottomRight: () => ({ bottom: '0px', right: '0px' }),
    topRight: () => ({ top: '0px', right: '0px' }),
};
//# sourceMappingURL=positions.js.map